import { Route, Routes, useNavigate } from "react-router-dom";
import MainEvent from "../components/Dashboard/EventDashboard/MainEvent";
import Location from "../components/Dashboard/EventDashboard/Location";
import Speakers from "../components/Dashboard/EventDashboard/Speakers";
import Sponsor from "../components/Dashboard/EventDashboard/Sponsor";
import Stall from "../components/Dashboard/EventDashboard/Stall";
import Agenda from "../components/Dashboard/EventDashboard/Agenda";
import LogoHeader from "../components/Dashboard/UserDashboard/LogoHeader";
import SideBar from "../components/Dashboard/EventDashboard/SideBar";
import MainHeader from "../components/Dashboard/EventDashboard/MainHeader";
import Registration from "../components/Dashboard/EventDashboard/Registration";
import { useState } from "react";
import Meeting from "../components/Dashboard/EventDashboard/Meeting";

const EventDashboard = () => {
  //eslint-disable-next-line
  const [activeSection, setActiveSection] = useState("");
  const navigate = useNavigate();

  //   Handles the click event of the sidebar item.
  //   It sets the activeSection state to the clicked section and navigates to the corresponding route.
  const handleActive = (section) => {
    setActiveSection(section);
    navigate(`${section}`);
  };

  return (
    <div className="EventDashboard">
      <div className="left-side-box">
        <LogoHeader />
        <SideBar activeSection={activeSection} handleActive={handleActive} />
      </div>
      <div className="right-side-box">
        <MainHeader />
        <div className="content-box">
          <Routes>
            <Route
              path="main-event"
              element={
                <MainEvent onNext={() => handleActive("registration")} />
              }
            />
            <Route path="location" element={<Location />} />
            <Route path="speakers" element={<Speakers />} />
            <Route path="sponsor" element={<Sponsor />} />
            <Route path="stalls" element={<Stall />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="registration" element={<Registration />} />
            <Route path="meetings" element={<Meeting />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default EventDashboard;
